import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-gray-900 text-white py-8">
    <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-start md:items-center space-y-6 md:space-y-0">
      <div className="flex flex-col items-start">
        <div className="flex items-center space-x-2 mb-4">
          <img 
            src="/assets/ac_logo.jpeg" 
            alt="Avalue Capital Logo" 
            className="h-10 w-auto object-contain"
          />
          <span className="text-lg font-semibold text-white">Avalue Capital</span>
        </div>
        <h3 className="font-bold text-lg mb-2">Quick Links</h3>
        <ul className="space-y-1">
          <li><Link to="/" className="hover:underline">Home</Link></li>
          <li><Link to="/doctor-loans" className="hover:underline">Doctor Loans</Link></li>
          <li><Link to="/equipment-loans" className="hover:underline">Equipment Loans</Link></li>
          <li><Link to="/project-loans" className="hover:underline">Project Loans</Link></li>
          <li><Link to="/contact" className="hover:underline">Contact</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="font-bold text-lg mb-2">Contact Info</h3>
        <p>Email: <a href="mailto:info@avaluecapital.com" className="text-red-400 underline">info@avaluecapital.com</a></p>
        <p>Contact Number: <a href="tel:7976467674" className="text-blue-300 underline">7976467674</a></p>
      </div>
      <div>
        <h3 className="font-bold text-lg mb-2">Branches</h3>
        <ul className="space-y-1">
          <li> Dinne Circle, Chikkanayakanahalli C.L. Road, Carmelram Post, Bengaluru - 560035. </li>    
     {/* <li> Hyderabad: Plot No.58, Guttala Begumpet, Madhapur Road </li>*/}
        </ul>
      </div>
    </div>
    <div className="text-center text-gray-400 text-xs mt-8">&copy; {new Date().getFullYear()} Avalue Capital. All rights reserved.</div>
  </footer>
);

export default Footer; 
